import { initCarousel } from './components/carousel';

document.addEventListener('DOMContentLoaded', () => {
  initNewsletterInputValidation();
});

function initNewsletterInputValidation() {
  const form = document.getElementById('discount-form') as HTMLFormElement;
  form.addEventListener('htmx:beforeRequest', (e) => {
    const form = document.getElementById(
      'discount-form',
    ) as HTMLFormElement | null;
    const emailInput = document.getElementById(
      'DiscountForm_Email',
    ) as HTMLInputElement | null;
    const emailError = document.getElementById('DiscountForm_Email-Error');

    if (!form || !emailInput || !emailError) return;

    const email = emailInput.value;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;
    if (!emailRegex.test(email)) {
      emailError.textContent = 'Please enter a valid email address';
      e.preventDefault();
    } else {
      emailError.textContent = '';
    }
  });
}
